import React from "react";

import Card from "../card";

class MainApp extends React.Component {
  render() {
    return (
      <div class="MainApp">
        <Card>{/* <Webcam /> without blinking */}</Card>
      </div>
    );
  }
}

export default MainApp;
